var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{ref:"pages",attrs:{"size":_vm.size,"current":_vm.pageNum,"page-size":_vm.pageSize,"total":_vm.pageTotal,"transfer":"","show-sizer":_vm.showSizer,"page-size-opts":_vm.PAGE_SIZE_OPTIONS,"show-total":""},on:{"on-change":_vm.changePage,"on-page-size-change":_vm.changePageSize}})
}
var staticRenderFns = []

export { render, staticRenderFns }